import { render, staticRenderFns } from "./language-selector.vue?vue&type=template&id=6c559879&scoped=true&"
import script from "./language-selector.vue?vue&type=script&lang=js&"
export * from "./language-selector.vue?vue&type=script&lang=js&"
import style0 from "./language-selector.vue?vue&type=style&index=0&id=6c559879&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c559879",
  null
  
)

export default component.exports